export const citiesData = [
  {
    images: [
      "https://images.trvl-media.com/hotels/70000000/69560000/69551900/69551801/dd25faec.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/70000000/69560000/69551900/69551801/c8b7c58e.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/70000000/69560000/69551900/69551801/1c8b133d.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/70000000/69560000/69551900/69551801/9f30adf4.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/70000000/69560000/69551900/69551801/35f415e9.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "1",
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3849.2130186418817!2d73.92099301432737!3d15.25617476476542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfb5c35157ad0b%3A0xd1a37e617e85cae9!2sFairfield%20by%20Marriott%20Goa%20Benaulim!5e0!3m2!1sen!2sin!4v1648666656270!5m2!1sen!2sin",
    isFav: false,
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Mobor Beach",
        distance: "58",
      },
      {
        logo: "MdLocationOn",
        locationName: "Holy Cross Chapel-Baradi",
        distance: "71",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baina Beach",
        distance: "114",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Goa (GOI-Dabolim)",
        distance: "79",
      },
    ],
    hotelName: "Fairfield by Marriott Goa Benaulim",
    place: "goa",
    city: "Benaulim",
    shortDescription: "Effortlessly Romantic Beach Holiday",
    description:
      "Find the beauty of simplicity in South Goa. Fairfield by Marriott Goa Benaulim is minutes from the pure sands of Benaulim Beach.",
    refund: "Refundable",
    rating: "2.6",
    paymentMode: "Reserve now, pay later",
    review: "Wonderful",
    reviewCount: "11",
    roomsLeft: "5",
    offerPrice: "1499",
    originalPrice: "2399",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/1000000/530000/523000/522986/546c8e4c.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/523000/522986/434198e3.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/523000/522986/w4000h2663x0y0-82e36e3f.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/523000/522986/w4000h2662x0y0-dbf99916.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/523000/522986/5e7f8086.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "2",
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.9619049788007!2d73.8072543143299!3d15.486481158905299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc085624c679b%3A0xd3f137e3ddd48a8c!2sGoa%20Marriott%20Resort%20%26%20Spa!5e0!3m2!1sen!2sin!4v1648667070661!5m2!1sen!2sin",
    isFav: false,
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Miramar Beach",
        distance: "10",
      },
      {
        logo: "MdLocationOn",
        locationName: "Church of Our Lady of Immaculate Conception",
        distance: "4",
      },
      {
        logo: "MdLocationOn",
        locationName: "Reis Magos Fort",
        distance: "13",
      },
    ],
    hotelName: "Goa Marriott Resort & Spa",
    city: "Panaji",
    place: "goa",
    shortDescription: "Take a Goa vacation by the bay",
    description:
      "Situated on the edge of the Miramar beach with picturesque views, enjoy luxury services coupled with warm Goan hospitality.",
    refund: "Fully refundable",
    rating: "3.5",
    paymentMode: "Reserve now, pay later",
    review: "Wonderful",
    reviewCount: "374",
    roomsLeft: "5",
    offerPrice: "1295",
    originalPrice: "1868",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/25000000/24060000/24057300/24057290/a10c98af.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/25000000/24060000/24057300/24057290/7589d012.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/25000000/24060000/24057300/24057290/1860bf90.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/25000000/24060000/24057300/24057290/e05799e2.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/25000000/24060000/24057300/24057290/9b648649.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "3",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.3399142319568!2d73.79182031433027!3d15.519898158048093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc1b35bc8a143%3A0xbe143f66fada742!2sHilton%20Goa%20Resort!5e0!3m2!1sen!2sin!4v1648667323453!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "St. Alex Church",
        distance: "7",
      },
      {
        logo: "MdLocationOn",
        locationName: "Reis Magos Fort",
        distance: "25",
      },
      {
        logo: "MdLocationOn",
        locationName: "Candolim Beach",
        distance: "25",
      },
    ],
    hotelName: "Hilton Goa Resort",
    city: "Saipem",
    place: "goa",
    shortDescription: "Great Small Breaks: Perfect Staycation",
    description:
      "Enjoy your stay inclusive of breakfast, one major meal, shared airport transfers, one Goan Masterclass and more",
    refund: "Refundable",
    rating: "2",
    paymentMode: "Reserve now, pay later",
    review: "Very good",
    reviewCount: "13",
    roomsLeft: "5",
    offerPrice: "1799",
    originalPrice: "2743",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/16000000/15440000/15439200/15439133/9415c6da.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/16000000/15440000/15439200/15439133/d952569d.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/16000000/15440000/15439200/15439133/f0a1ad01.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/16000000/15440000/15439200/15439133/235e6e3f.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/16000000/15440000/15439200/15439133/28c48ea8.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "4",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3842.797420105814!2d73.73475901433129!3d15.602468755922533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfe96f8008739f%3A0x466052ed5d25e27e!2sW%20Goa!5e0!3m2!1sen!2sin!4v1648667937246!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Vagator Beach",
        distance: "1",
      },
      {
        logo: "MdLocationOn",
        locationName: "Chapora Fortress",
        distance: "7",
      },
      {
        logo: "MdLocationOn",
        locationName: "Chapora Beach",
        distance: "19",
      },
    ],
    hotelName: "W Goa",
    city: "Chapora",
    place: "goa",
    shortDescription: "Turn it up at the hottest escape in Goa",
    description:
      "Escape to limitless luxuries as you soak in the scene from our sea front villas & chalets. Book your Escape now.",
    refund: "Fully refundable",
    rating: "4.2",
    paymentMode: "Reserve now, pay later",
    review: "Very good",
    reviewCount: "87",
    roomsLeft: "4",
    offerPrice: "3395",
    originalPrice: "4066",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/61000000/60650000/60643100/60643033/7bd2c108.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/61000000/60650000/60643100/60643033/cbcaf799.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/61000000/60650000/60643100/60643033/82d91a4e.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/61000000/60650000/60643100/60643033/8b0eea33.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/61000000/60650000/60643100/60643033/b08238ff.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "5",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.645379309614!2d73.76984121433014!3d15.503495558469064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc1d675c79e2d%3A0xbdc7b06821609fef!2sHoliday%20Inn%20Goa%20Candolim%2C%20an%20IHG%20Hotel!5e0!3m2!1sen!2sin!4v1648668107680!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Candolim Beach",
        distance: "6",
      },
      {
        logo: "MdLocationOn",
        locationName: "Vagator Beach",
        distance: "46",
      },
      {
        logo: "MdLocationOn",
        locationName: "Ashvem Beach",
        distance: "66",
      },
    ],
    hotelName: "Holiday Inn Goa Candolim",
    city: "Sinquerim",
    place: "goa",
    shortDescription: "Great Small Breaks: Perfect Staycation",
    description:
      "Enjoy your stay inclusive of breakfast, one major meal, shared airport transfers, one Goan Masterclass and more",
    refund: "Fully refundable",
    rating: "3.0",
    paymentMode: "Reserve now, pay later",
    review: "good",
    reviewCount: "1",
    roomsLeft: "3",
    offerPrice: "3350",
    originalPrice: "4573",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/11000000/10550000/10547600/10547516/abca2a26.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/11000000/10550000/10547600/10547516/9759e533.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/11000000/10550000/10547600/10547516/f9bb0024.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/11000000/10550000/10547600/10547516/33d6bee0.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/11000000/10550000/10547600/10547516/e4d85275.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    isFav: false,
    id: "6",
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3848.095726306611!2d73.90019731432801!3d15.317032063224982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfb6e55dc86433%3A0x343f2d8ad5194dc1!2sPlanet%20Hollywood%20Beach%20Resort!5e0!3m2!1sen!2sin!4v1648668411601!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Majorda Beach",
        distance: "4",
      },
      {
        logo: "MdLocationOn",
        locationName: "Arossim Beach",
        distance: "4",
      },
      {
        logo: "MdLocationOn",
        locationName: "Sunset Beach",
        distance: "6",
      },
    ],
    hotelName: "Planet Hollywood Goa Beach Resort",
    city: "Uttorda",
    place: "goa",
    shortDescription: "Romantic Beach Holiday",
    description:
      "Find the beauty of simplicity in South Goa. Fairfield by Marriott Goa Benaulim is minutes from the pure sands of Benaulim Beach.",
    refund: "Refundable",
    rating: "4.2",
    paymentMode: "Reserve now, pay later",
    review: "Very good",
    reviewCount: "65",
    roomsLeft: "8",
    offerPrice: "9500",
    originalPrice: "10089",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/1000000/890000/881600/881558/033247ff.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/890000/881600/881558/c19e7064.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/890000/881600/881558/35f575c6.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/890000/881600/881558/f2639ea5.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/890000/881600/881558/bb84cfcf.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    isFav: false,
    id: "7",
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3848.0636328008945!2d73.90037611432801!3d15.31877666318075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfb6e540bbaf63%3A0x4e6adb18cf5c1830!2sKenilworth%20Resort%20%26%20Spa%2C%20Goa!5e0!3m2!1sen!2sin!4v1648668554829!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Uttorda Beach",
        distance: "5",
      },
      {
        logo: "MdLocationOn",
        locationName: "Arossim Beach",
        distance: "4",
      },
      {
        logo: "MdLocationOn",
        locationName: "Majorda Beach",
        distance: "5",
      },
    ],
    hotelName: "Kenilworth Resort & Spa",
    city: "Uttorda",
    place: "goa",
    shortDescription: "Hottest escape in goa",
    description:
      "Escape to limitless luxuries as you soak in the scene from our sea front villas & chalets. Book your Escape now.",
    refund: "Fully refundable",
    refund: "Fully refundable",
    rating: "4.0",
    paymentMode: "Reserve now, pay later",
    review: "Very good",
    reviewCount: "128",
    roomsLeft: "1",
    offerPrice: "11999",
    originalPrice: "14159",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/3000000/2710000/2703400/2703358/00a8ece2.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/3000000/2710000/2703400/2703358/ee766bf2.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/3000000/2710000/2703400/2703358/05cffa42.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/3000000/2710000/2703400/2703358/c4165ed9.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/3000000/2710000/2703400/2703358/3a8ae8de.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "8",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.8218278632276!2d73.81833891433008!3d15.494013058712246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfc0c457a2a095%3A0x20cfa5e3feb69355!2sVivanta%20Goa%2C%20Panaji!5e0!3m2!1sen!2sin!4v1648668864605!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Mandovi River",
        distance: "6",
      },
      {
        logo: "MdLocationOn",
        locationName: "Church of Our Lady of Immaculate Conception",
        distance: "16",
      },
      {
        logo: "MdLocationOn",
        locationName: "Deltin Royale Casino",
        distance: "2",
      },
    ],
    hotelName: "Vivanta Goa, Panaji",
    place: "goa",
    city: "Panaji",
    shortDescription: "Rediscover Goa in Panaji",
    description:
      "Located in Anjuna, The Westin Goa is perfect for staycations, families, and young couples. Shuttle service to airport provided.",
    refund: "Fully refundable",
    rating: "4.6",
    paymentMode: "Reserve now, pay later",
    review: "Wonderful",
    reviewCount: "342",
    roomsLeft: "3",
    offerPrice: "9720",
    originalPrice: "11470",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/4000000/3090000/3084000/3083952/3706424f.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3090000/3084000/3083952/6dbab5eb.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3090000/3084000/3083952/5b68bfa9.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3090000/3084000/3083952/60fd169f.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3090000/3084000/3083952/9b980666.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "9",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3848.5727597611044!2d73.90862351432774!3d15.291077663882662!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfb698b8211dc7%3A0x1e4d01aacdd22c08!2sBeleza%20By%20The%20Beach!5e0!3m2!1sen!2sin!4v1648669027975!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Colva Beach",
        distance: "1",
      },
      {
        logo: "MdLocationOn",
        locationName: "Holy Cross Chapel-Baradi",
        distance: "27",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baina Beach",
        distance: "36",
      },
    ],
    hotelName: "Beleza By The Beach",
    city: "Fatona",
    place: "goa",
    shortDescription: "Visit for perfect staycation.",
    description:
      "Enjoy your stay inclusive of breakfast, one major meal, shared airport transfers, one Goan Masterclass and more",
    refund: "Fully refundable",
    refund: "Fully refundable",
    rating: "4.3",
    paymentMode: "Reserve now, pay later",
    review: "Excellent",
    reviewCount: "290",
    roomsLeft: "5",
    offerPrice: "7499",
    originalPrice: "8439",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/67000000/66040000/66031300/66031217/b97c090e.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/67000000/66040000/66031300/66031217/18320cac.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/67000000/66040000/66031300/66031217/249ec951.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/67000000/66040000/66031300/66031217/a3a5f3d2.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/67000000/66040000/66031300/66031217/7577bdf7.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "10",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3843.04887825973!2d73.74114391433113!3d15.589037156269105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbfe9f140908b13%3A0x68681dc8d8258f5f!2sThe%20Westin%20Goa!5e0!3m2!1sen!2sin!4v1648669168397!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Anjuna Beach",
        distance: "18",
      },
      {
        logo: "MdLocationOn",
        locationName: "Arambol Beach",
        distance: "52",
      },
      {
        logo: "MdLocationOn",
        locationName: "Arambol Sweet Water Lake",
        distance: "67",
      },
    ],
    hotelName: "The Westin Goa",
    place: "goa",
    city: "Anjuna",
    shortDescription: "Rediscover Goa in Anjuna",
    description:
      "Located in Anjuna, The Westin Goa is perfect for staycations, families, and young couples. Shuttle service to airport provided.",
    refund: "Fully refundable",
    rating: "4.6",
    paymentMode: "Reserve now, pay later",
    review: "Wonderful",
    reviewCount: "13",
    roomsLeft: "5",
    offerPrice: "7500",
    originalPrice: "8930",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/2000000/1140000/1135700/1135650/5c0feeaf.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/2000000/1140000/1135700/1135650/6f30ebe1.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/2000000/1140000/1135700/1135650/edcd7bb5.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/2000000/1140000/1135700/1135650/c0b94461.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/2000000/1140000/1135700/1135650/6a188c02.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "11",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d971.9904643380512!2d77.61165308543903!3d12.974291449160976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16846913b3b1%3A0xb60950daef881157!2sRoyal%20Orchid%20Central%20Bengaluru!5e0!3m2!1sen!2sin!4v1648667984485!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "M.G. Road",
        distance: "2",
      },
      {
        logo: "MdLocationOn",
        locationName: "Brigade Road",
        distance: "10",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "53",
      },
    ],
    hotelName: "Royal Orchid Central Bangalore",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "Stay in the perfect place.",
    description:
      "Rediscover and unravel the essence of the garden city amidst our warm hospitality and lush green Bangalore Turf Club backdrop.",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "3.6",
    review: "Good",
    reviewCount: "158",
    roomsLeft: "6",
    offerPrice: "7450",
    originalPrice: "6184",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/24000000/23090000/23088600/23088585/7c4b2896.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23090000/23088600/23088585/4b589b61.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23090000/23088600/23088585/4b589b61.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23090000/23088600/23088585/007ac5ad.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23090000/23088600/23088585/007ac5ad.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "12",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.732072577225!2d77.72789491376258!3d12.98898091801356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11eec9986c7f%3A0x6e8715fd5f4e9861!2sSheraton%20Grand%20Bengaluru%20Whitefield%20Hotel%20%26%20Convention%20Center!5e0!3m2!1sen!2sin!4v1648668893808!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "M.G. Road",
        distance: "47",
      },
      { logo: "MdLocationOn", locationName: "", distance: "59" },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "73",
      },
    ],
    hotelName: "Sheraton Grand Bengaluru Whitefield",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "Stay More, Save More",
    description:
      "With the Long Stay Package, book 5 nights or more and enjoy a host of exclusive discounts & benefits on dining and laundry",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.7",
    review: "Exceptional",
    reviewCount: "31",
    roomsLeft: "5",
    offerPrice: "11500",
    originalPrice: "13570",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/28000000/27050000/27041300/27041208/9e84e1d7.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27050000/27041300/27041208/7e569ab7.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27050000/27041300/27041208/cf803f86.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27050000/27041300/27041208/cf803f86.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27050000/27041300/27041208/724a1464.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "13",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3887.732072577225!2d77.72789491376258!3d12.98898091801356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1648669551773!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Race Course Road",
        distance: "7",
      },
      {
        logo: "MdLocationOn",
        locationName: "Gandhi Bhavan",
        distance: "8",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "48",
      },
    ],
    hotelName: "Renaissance Bengaluru Race Course Hotel",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "Indulgent Staycay With Marriott Bonvoy",
    description:
      "Rediscover and unravel the essence of the garden city amidst our warm hospitality and lush green Bangalore Turf Club backdrop.",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.6",
    review: "Wonderful",
    reviewCount: "85",
    roomsLeft: "5",
    offerPrice: "7900",
    originalPrice: "8848",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/4000000/3120000/3114400/3114317/f0784799.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3120000/3114400/3114317/bcd4d43b.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3120000/3114400/3114317/d20cad2a.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3120000/3114400/3114317/d20cad2a.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/4000000/3120000/3114400/3114317/352c6e84.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "14",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.075977265744!2d77.59336341376229!3d12.96699001849042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0276dd2cf216d3%3A0x523e0c08edd084f2!2sITC%20Gardenia%2C%20a%20Luxury%20Collection%20Hotel%2C%20Bengaluru!5e0!3m2!1sen!2sin!4v1648669850808!5m2!1sen!2sin",
    exploreArea: [
      { logo: "MdLocationOn", locationName: "UB City", distance: "1" },
      {
        logo: "MdLocationOn",
        locationName: "Cubbon Park",
        distance: "3",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "34",
      },
    ],
    hotelName: "ITC Gardenia, a Luxury Collection Hotel, Bengaluru",
    city: "Bangaluru",
    place: "bengaluru",
    shortDescription: "Head for Responsible Luxury",
    description:
      "Experience a luxury stay with scrumptious b'fast at Award winning restaurants with zero carbon footprints. Committed to WeAssure",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.6",
    review: "Wonderful",
    reviewCount: "278",
    roomsLeft: "5",
    offerPrice: "12500",
    originalPrice: "14750",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/5000000/4300000/4290600/4290528/3ba98308.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/5000000/4300000/4290600/4290528/3ba98308.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/5000000/4300000/4290600/4290528/4b5e3100.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/5000000/4300000/4290600/4290528/5b77956b.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/5000000/4300000/4290600/4290528/04384be9.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "15",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.359992989301!2d77.55284701376283!3d13.012732317497733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d78c39ed1d7%3A0x6832860dbb5cd434!2sSheraton%20Grand%20Bangalore%20Hotel%20at%20Brigade%20Gateway!5e0!3m2!1sen!2sin!4v1648670059239!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "World Trade Centre",
        distance: "4",
      },
      {
        logo: "MdLocationOn",
        locationName: "Orion Mall",
        distance: "2",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "46",
      },
    ],
    hotelName: "Sheraton Grand Bangalore Hotel at Brigade Gateway",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "Indulgent safecation with MarriottBonvoy",
    description:
      "Pamper your loved ones with inclusions like In-room movie experience, all meals, Kids stay for free, & you earn 5k Bonvoy points.",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.6",
    review: "Good",
    reviewCount: "239",
    roomsLeft: "4",
    offerPrice: "10550",
    originalPrice: "12449",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/13000000/12250000/12246300/12246261/264e5bce.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12250000/12246300/12246261/51428abe.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12250000/12246300/12246261/a1715b40.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12250000/12246300/12246261/dc836ce0.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12250000/12246300/12246261/24ce0cec.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "16",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.686767417039!2d77.58610431376259!3d12.991875217950774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae160d16f18803%3A0x93e9c670e6e9c7e6!2sShangri-La%20Bengaluru!5e0!3m2!1sen!2sin!4v1648670301434!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Bangalore Palace",
        distance: "10",
      },
      {
        logo: "MdLocationOn",
        locationName: "Cubbon Park",
        distance: "18",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "45",
      },
    ],
    hotelName: "Shangri-La Bengaluru",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "Head for Responsible Luxury",
    description:
      "Rediscover and unravel the essence of the garden city amidst our warm hospitality and lush green Bangalore Turf Club backdrop.",
    refund: "fully refundable",
    paymentMode: "Reserve without a credit card",
    rating: "4.7",
    review: "Exceptional",
    reviewCount: "204",
    roomsLeft: "10",
    offerPrice: "9775",
    originalPrice: "11535",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/1000000/860000/851500/851448/360577d2.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/860000/851500/851448/d587bd8e.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/860000/851500/851448/c5bccfca.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/860000/851500/851448/360577d2.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/860000/851500/851448/50326a44.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "17",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.1658479148095!2d77.64668091430424!3d12.961237218613684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1406652d36fd%3A0x6d066f2487949365!2sThe%20Leela%20Palace%2C%2080%20Feet%20Rd%2C%20HAL%202nd%20Stage%2C%20Kodihalli%2C%20Bengaluru%2C%20Karnataka%20560008!5e0!3m2!1sen!2sin!4v1648760228534!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Intel Technology India",
        distance: "3",
      },
      {
        logo: "MdLocationOn",
        locationName: "IBM Offices",
        distance: "3",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "38",
      },
    ],
    hotelName: "The Leela Palace Bengaluru",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve without a credit card",
    rating: "4.7",
    review: "Exceptional",
    reviewCount: "235",
    roomsLeft: "4",
    offerPrice: "15225",
    originalPrice: "16169",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/64000000/63860000/63857600/63857550/5edcffa2.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/64000000/63860000/63857600/63857550/53cdd0db.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/64000000/63860000/63857600/63857550/ee86d69e.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/64000000/63860000/63857600/63857550/8d5ffdaf.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/64000000/63860000/63857600/63857550/5edcffa2.jpg?impolicy=resizecrop&rw=598&ra=fit",
    ],
    id: "18",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.2295294711644!2d77.64087731430538!3d13.084634615929392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae19ddc5c6076f%3A0x9c2f5e01fcf17215!2sThe%20Leela%20Bhartiya%20City%2C%20Hotel%20Convention%20%26%20Residences%2C%20Bengaluru!5e0!3m2!1sen!2sin!4v1648760364019!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Eco Space Business Park",
        distance: "29",
      },
      {
        logo: "MdLocationOn",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "39",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Lalbagh Botanical Gardens",
        distance: "68",
      },
    ],
    hotelName: "The Leela Bhartiya City Bengaluru",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "Bliss is all around. Escape into it.",
    description:
      "Seamless connectivity from the airport, lush landscapes and lavish accommodations. Inclusive of 1 + 1 on any select beverages",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.8",
    review: "Exceptional",
    reviewCount: "150",
    roomsLeft: "8",
    offerPrice: "9700",
    originalPrice: "10301",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/27000000/26560000/26554200/26554165/a0118907.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/27000000/26560000/26554200/26554165/bff593d0.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/27000000/26560000/26554200/26554165/e51d0970.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/27000000/26560000/26554200/26554165/96acab3f.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/27000000/26560000/26554200/26554165/260db6de.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "19",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.257899659278!2d77.58290891376289!3d13.019241917356176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16773125c81f%3A0xc672addd71b0266a!2sFour%20Seasons%20Hotel%20Bengaluru%20at%20Embassy%20ONE!5e0!3m2!1sen!2sin!4v1648670938699!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Fun World",
        distance: "2",
      },
      {
        logo: "MdLocationOn",
        locationName: "Sankey Tank",
        distance: "3",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "37",
      },
    ],
    hotelName: "Four Seasons Hotel Bengaluru at Embassy One",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.8",
    review: "Good",
    reviewCount: "36",
    roomsLeft: "3",
    offerPrice: "11475",
    originalPrice: "13541",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/1000000/530000/526400/526338/8ac86035.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/526400/526338/f6537156.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/526400/526338/450dbcab.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/526400/526338/2395a505.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/1000000/530000/526400/526338/9aa64b33.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "20",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.9771474420954!2d77.61748011376241!3d12.973313418353367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1686b281d2a3%3A0xfe17a276bcf050c5!2sTaj%20MG%20Road%2C%20Bengaluru!5e0!3m2!1sen!2sin!4v1648671200618!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "M.G. Road",
        distance: "1",
      },
      {
        logo: "MdLocationOn",
        locationName: "Ulsoor Lake",
        distance: "6",
      },
      {
        logo: "MdOutlineAirplanemodeActive",
        locationName: "Bengaluru (BLR-Kempegowda Intl.)",
        distance: "34",
      },
    ],
    hotelName: "Taj MG Road, Bengaluru",
    city: "Bengaluru",
    place: "bengaluru",
    shortDescription: "",
    description: "",
    refund: "",
    paymentMode: "Reserve now, pay later",
    rating: "4.3",
    review: "Excellent",
    reviewCount: "380",
    roomsLeft: "15",
    offerPrice: "10500",
    originalPrice: "12390",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/18000000/17790000/17785800/17785740/371b7fa8.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/18000000/17790000/17785800/17785740/d4dd2e63.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/18000000/17790000/17785800/17785740/c2453c69.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/18000000/17790000/17785800/17785740/69eeb1d3.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/18000000/17790000/17785800/17785740/c43c26d0.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "21",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3359.801583535852!2d74.91151181449892!3d32.63810698101409!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e9c4ebd40b93b%3A0x1c540fb4c8f921d6!2sHotel%20Trinetar%20Gardens%20%26%20Banquets%20(%20A%20Unit%20of%20Sudershan%20Hotels%20%26%20Resorts)!5e0!3m2!1sen!2sin!4v1648669675234!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Jammu University",
        distance: "12",
      },
      {
        logo: "MdLocationOn",
        locationName: "Balidan Stambh",
        distance: "12",
      },
      {
        logo: "MdLocationOn",
        locationName: "Bagh-e-Bahu Park",
        distance: "13",
      },
    ],
    hotelName: "Hotel Trinetar Gardens",
    city: "Jammu",
    place: "jammu",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "3.5",
    review: "Good",
    reviewCount: "2",
    roomsLeft: "4",
    offerPrice: "2800",
    originalPrice: "3136",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/21000000/20950000/20949100/20949056/c1ef5a68.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/21000000/20950000/20949100/20949056/6b0dde80.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/21000000/20950000/20949100/20949056/a27fa31c.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/21000000/20950000/20949100/20949056/40aab17b.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/21000000/20950000/20949100/20949056/a46653d7.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "22",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.547694381216!2d74.92346931466992!3d32.98933308043743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e78e14763b7ed%3A0xcbe37b30ef558bc0!2sHotel%20Continent%20Panchvati%20Katra!5e0!3m2!1sen!2sin!4v1648669901660!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Raghunath Temple",
        distance: "13",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shalimar Park",
        distance: "18",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baba Sihad Waterfall",
        distance: "27",
      },
    ],
    hotelName: "Continent Panchvati Hotel Katra",
    city: "Jammu",
    place: "jammu",
    shortDescription: "Good Residency",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "3.7",
    review: "Good",
    reviewCount: "10",
    roomsLeft: "5",
    offerPrice: "4999",
    originalPrice: "5899",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/13000000/12710000/12708200/12708194/99481db3.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12710000/12708200/12708194/7a4b2151.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12710000/12708200/12708194/c15135e9.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12710000/12708200/12708194/3fd3cd11.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/13000000/12710000/12708200/12708194/af97b18e.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "23",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.1308223904375!2d74.83199831470115!3d34.117400421742055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38e185a4096daff5%3A0x8e17c2709b3da744!2sLily%20of%20Nageen!5e0!3m2!1sen!2sin!4v1648670028975!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Hari Parbat Fort",
        distance: "5",
      },
      {
        logo: "MdLocationOn",
        locationName: "Mughal Gardens",
        distance: "8",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shankaracharya Reserved Forest",
        distance: "17",
      },
    ],
    hotelName: "Lily of Nageen",
    city: "Jammu",
    place: "jammu",
    shortDescription: "Entire house boat",
    description: "Nagīn Bāgh Breakfast included",
    refund: "",
    paymentMode: "",
    rating: "4.5",
    review: "Wonderful",
    reviewCount: "4",
    roomsLeft: "2",
    offerPrice: "4113",
    originalPrice: "4606",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/28000000/27120000/27112100/27112020/00218909.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27120000/27112100/27112020/2357df20.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27120000/27112100/27112020/a7c350e7.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27120000/27112100/27112020/9a81d0f4.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/28000000/27120000/27112100/27112020/0e5ea582.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "24",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.5533361692264!2d74.92785101466994!3d32.989184280444924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e78e6516c714f%3A0x2b8bf126b45df8a7!2sHotel%20Rama%20Trident!5e0!3m2!1sen!2sin!4v1648670184753!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Raghunath Temple",
        distance: "13",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shalimar Park",
        distance: "18",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baba Sihad Waterfall",
        distance: "63",
      },
    ],
    hotelName: "Hotel Rama Trident",
    city: "Jammu",
    place: "jammu",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.0",
    review: "Very Good",
    reviewCount: "1",
    roomsLeft: "4",
    offerPrice: "6200",
    originalPrice: "7200",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/33000000/32530000/32525200/32525180/cf9fe5d7.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/33000000/32530000/32525200/32525180/357a9cac.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/33000000/32530000/32525200/32525180/f09aedcc.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/33000000/32530000/32525200/32525180/9ee11653.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/33000000/32530000/32525200/32525180/6aad0feb.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "25",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.109254489847!2d74.9186170146688!3d32.94812478254927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e7f2764bc5fe1%3A0x3e61bb042f657e12!2sCountry%20Resort%20By%20AHRPL%20Vaishnodevi%20Katra!5e0!3m2!1sen!2sin!4v1648670313141!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Deva Maai Temple",
        distance: "3",
      },
      {
        logo: "MdLocationOn",
        locationName: "Raghunath Temple",
        distance: "7",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shalimar Park",
        distance: "16",
      },
    ],
    hotelName: "Country Resort By AHRPL - Katra",
    city: "Jammu",
    place: "jammu",
    shortDescription: "Katra",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.7",
    review: "Exceptional",
    reviewCount: "7",
    roomsLeft: "3",
    offerPrice: "5875",
    originalPrice: "5922",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/69000000/68740000/68735200/68735142/d4380d89.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/69000000/68740000/68735200/68735142/4811b5fd.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/69000000/68740000/68735200/68735142/ff01c930.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/69000000/68740000/68735200/68735142/e4f5b06c.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/69000000/68740000/68735200/68735142/901bb74c.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "26",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.926832892451!2d75.33319831467253!3d33.084709475540876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391dc81bffffffc9%3A0x7780341c56696d6a!2sSkyview%20by%20Empyrean!5e0!3m2!1sen!2sin!4v1648670462807!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Patnitop Park",
        distance: "55",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baglihar Dam",
        distance: "63",
      },
      {
        logo: "MdLocationOn",
        locationName: "Sanasar Lake",
        distance: "100",
      },
    ],
    hotelName: "Skyview by Empyrean",
    city: "Jammu",
    place: "jammu",
    shortDescription: "Patnitop",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.0",
    review: "",
    reviewCount: "",
    roomsLeft: "4",
    offerPrice: "11111",
    originalPrice: "11800",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/71000000/71000000/70992700/70992628/49181598.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/71000000/71000000/70992700/70992628/5c7ced2e.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/71000000/71000000/70992700/70992628/0534bbdf.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/71000000/71000000/70992700/70992628/7c0e4efc.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/71000000/71000000/70992700/70992628/c6f29de2.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "27",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3358.935748770786!2d74.94074231466104!3d32.661153897192385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e9d23b1b628af%3A0x630730ca3ddbf153!2sFour%20A%20Lords%20Resort!5e0!3m2!1sen!2sin!4v1648670603806!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Bahu Fort",
        distance: "11",
      },
      {
        logo: "MdLocationOn",
        locationName: "Balidan Stambh",
        distance: "11",
      },
      {
        logo: "MdLocationOn",
        locationName: "Bagh-e-Bahu Park",
        distance: "13",
      },
    ],
    hotelName: "Four A Lords Resort Jammu",
    city: "Jammu",
    place: "jammu",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "3.6",
    review: "Good",
    reviewCount: "5",
    roomsLeft: "3",
    offerPrice: "4500",
    originalPrice: "5040",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/36000000/35800000/35796500/35796427/2862a13d.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/36000000/35800000/35796500/35796427/aa834f7a.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/36000000/35800000/35796500/35796427/1d88eb7c.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/36000000/35800000/35796500/35796427/a727844c.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/36000000/35800000/35796500/35796427/b372ec8d.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "28",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.545036514933!2d74.91963351466995!3d32.989403180433804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e796484c7bb21%3A0x7832b61f88c56ade!2sHotel%20Mahaluxmi%20palace%20katra!5e0!3m2!1sen!2sin!4v1648670741126!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Raghunath Temple",
        distance: "17",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shalimar Park",
        distance: "20",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baba Sihad Waterfall",
        distance: "60",
      },
    ],
    hotelName: "Hotel Maha Luxmi Palace",
    city: "Jammu",
    place: "jammu",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "4.5",
    review: "Wonderful",
    reviewCount: "2",
    roomsLeft: "2",
    offerPrice: "1750",
    originalPrice: "1999",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/12000000/11850000/11849100/11849006/88fd6eb0.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/12000000/11850000/11849100/11849006/02fe9360.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/12000000/11850000/11849100/11849006/252f07b7.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/12000000/11850000/11849100/11849006/fa8408be.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/12000000/11850000/11849100/11849006/bbacd82c.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "29",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.5691580792877!2d74.91857841466988!3d32.9887669804664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e791e20bf43f1%3A0xad9fc504f6cb89ad!2sHotel%20Devi%20Grand!5e0!3m2!1sen!2sin!4v1648670889703!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Raghunath Temple",
        distance: "18",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shalimar Park",
        distance: "11",
      },
      {
        logo: "MdLocationOn",
        locationName: "Baba Sihad Waterfall",
        distance: "26",
      },
    ],
    hotelName: "Hotel Devi Grand",
    city: "Jammu",
    place: "jammu",
    shortDescription: "",
    description: "",
    refund: "Fully refundable",
    paymentMode: "Reserve now, pay later",
    rating: "2.6",
    review: "Good",
    reviewCount: "8",
    roomsLeft: "5",
    offerPrice: "2857",
    originalPrice: "3200",
  },
  {
    images: [
      "https://images.trvl-media.com/hotels/24000000/23040000/23037800/23037775/04336d0b.jpg?impolicy=resizecrop&rw=598&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23040000/23037800/23037775/04b60ef5.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23040000/23037800/23037775/f753b528.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23040000/23037800/23037775/043b8062.jpg?impolicy=resizecrop&rw=297&ra=fit",
      "https://images.trvl-media.com/hotels/24000000/23040000/23037800/23037775/313f7a66.jpg?impolicy=resizecrop&rw=297&ra=fit",
    ],
    id: "30",
    isFav: false,
    location:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26434.87802491607!2d74.81745683955076!3d34.0859233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38e18579b84d365f%3A0x19a4c32d3e86c551!2sShiraz%20Group%20of%20Houseboats!5e0!3m2!1sen!2sin!4v1648671049377!5m2!1sen!2sin",
    exploreArea: [
      {
        logo: "MdLocationOn",
        locationName: "Lal Chowk",
        distance: "4",
      },
      {
        logo: "MdLocationOn",
        locationName: "Hari Parbat Fort",
        distance: "5",
      },
      {
        logo: "MdLocationOn",
        locationName: "Shankaracharya Reserved Forest",
        distance: "11",
      },
    ],
    hotelName: "Shiraz Deluxe Houseboat",
    city: "Jammu",
    place: "jammu",
    shortDescription: "Entire house boat",
    description: "Dal Lake",
    refund: "",
    paymentMode: "",
    rating: "3.5",
    review: "Very Good",
    reviewCount: "6",
    roomsLeft: "3",
    offerPrice: "2699",
    originalPrice: "3023",
  },
];
